'use client';

import { Icon, IconName, IconSize, View } from '@bytel/trilogy-react-ts';

export default function CatalogOffersLink({
    showCatalogOffers,
    onClick,
}: {
    showCatalogOffers: boolean;
    onClick: () => void;
}) {
    return (
        <View flexable className='icon-and-text is-centered'>
            <a className='button-clear link has-text-blue-byou has-lineheight-2' onClick={onClick}>
                {showCatalogOffers ? 'Masquer ces forfaits' : 'Afficher les autres forfaits B&You'}
            </a>
            <Icon
                name={IconName.ARROW_DOWN}
                size={IconSize.SMALL}
                className='animated'
                style={{
                    transform: `rotate(${showCatalogOffers ? 180 : 0}deg)`,
                }}
            />
        </View>
    );
}
